// extracted by mini-css-extract-plugin
module.exports = {"Menu":"iTW9hr"};